import { WriteRouteTemplate } from '@/service';

/**
 * @class @name WriteRouteTemplateStore
 * @description Exposes factfind template store module
 */
export default class WriteRouteTemplateStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {
			templates: undefined
		};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {
			/**
			 * @name setTemplates
			 * @description Set fact find templates
			 * @param {Object} state
			 * @param {Array} templates
			 */
			setTemplates(state, templates) {
				state.templates = templates;
			}
		};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name fetchTemplateList
			 * @description Fetch all fact find templates
			 * @param {Object} context
			 */
			async fetchTemplateList({ commit }) {
				const { data } = await WriteRouteTemplate.list({ where: [{ "app.matter.data->>'master'": 'true' }] });
				commit('setTemplates', data.data);
			},

			/**
			 * @async @name createTemplate
			 * @description Create a fact find template
			 * @param {Object} context
			 * @param {Object} payload
			 */
			async createTemplate(context, payload) {
				return WriteRouteTemplate.create(payload);
			},

			/**
			 * @async @name modifyTemplate
			 * @param {function} commit
			 * @param {Object} data
			 */
			modifyTemplate(context, data) {
				let { id, payload } = data;
				return WriteRouteTemplate.modify(id, payload);
			},

			/**
			 * @async @name deleteTemplate
			 * @param {function} commit
			 * @param {String} id
			 */
			async deleteTemplate(context, id) {
				return WriteRouteTemplate.delete(id);
			}
		};
	}
}
